module.exports = __webpack_public_path__ + "e1e0c938a891f78375b01ce50256ec48.png";